---
meta:
  - title: Les cartes cadeau pour découvrir la poterie
  - name: description
    content: Pour les fêtes pensez à une activité originale, la Poterie! En individuelle ou en couple à l'atelier à Ste Clotilde de la Réunion 974. Les cartes cadeau sont maintenant disponibles, vous pouvez offrir le plaisir de la céramique à la personne de votre choix.
date: 2021-11-27T20:00:00Z
author: "Atelier Egon"
authorImage: "/atelier-egon-square.svg"
image: https://res.cloudinary.com/phildl-cloudinary/image/upload/v1638032059/atelieregon/atelier-egon-carte-cadeau_s2egzq.png
thumbnail: https://res.cloudinary.com/phildl-cloudinary/image/upload/w_554,h_383,c_scale,f_auto/v1638032059/atelieregon/atelier-egon-carte-cadeau_s2egzq.png

handle:
  scripts:
    - { src: "https://cdn.giftup.app/dist/gift-up.js" }
---

import { GiftupGiftcard } from "~/ui/frontend/giftup-giftcard.tsx";

## Les cartes cadeau !

Pour les fêtes de fin d'année, ou juste l'envie de faire plaisir, offrez la découverte de la Poterie à la personne de votre choix. Grace à la carte cadeau Atelier Egon, l'heureuse personne recevra un lien contenant votre message personnalisé et sa carte cadeau.

Elle aura également toutes les instructions pour choisir la date de sa session de poterie comme elle le voudra. Le processus est très simple et vous pouvez directement en ligne de manière sécurisée! Vous êtes certains de proposer une activité originale à la Réunion à une personne aimée.

## Contenu de la session individuelle

Session individuelle de Poterie d'une durée de 1H45 à l'Atelier inclus:

- Découverte du Tour de potier.
- Vous pouvez créer un set de **2 pièces**.
- Personnalisation, et finition de votre pièce par l'Atelier si vous le souhaitez.
- Cuisson, émaillage de vos créations pour les récupérer 1 à 2 semaine plus tard.

<GiftupGiftcard />

## Achat en ligne sécurisé

Tous les paiements par carte bancaire sont 100% sécurisés par la plateforme Stripe, conformément aux dispositifs de sécurité interbancaires français et internationaux. Stripe permet à l’internaute d’effectuer ses achats en ligne en toute sécurité et en toute sérénité.
